/**
 * Sacred Geometry
 *
 * Create page background element: rotating wireframe rings, diamond, hexagon,
 * radiating rays, and pulsing center point. All purely decorative.
 */

import React from 'react';

const RAY_COUNT = 12;

export const SacredGeometry: React.FC = () => {
  return (
    <div className="geo-layer">
      <div className="geo-ring-outer" />
      <div className="geo-ring-inner" />
      <div className="geo-diamond" />
      <div className="geo-hex" />
      <div className="geo-rays">
        {Array.from({ length: RAY_COUNT }, (_, i) => (
          <div key={i} className="geo-ray" />
        ))}
      </div>
      <div className="geo-center" />
    </div>
  );
};
